<template>
    <div class="box-second">
        <p class="title-crumb">
            <el-breadcrumb separator-class="el-icon-arrow-right color3">
                <el-breadcrumb-item>劳务管理</el-breadcrumb-item>
                <el-breadcrumb-item>人员定位</el-breadcrumb-item>
            </el-breadcrumb>
        </p>
        <div class="main" style="flex-wrap: wrap;">
            <!-- <div class="main-left">
                <p class="main-left-p">
                    <span>共{{deviceList.length}}个设备</span>
                </p>
                <div class="main-left-list">
                    <ul>
                        <li v-for="(item,index) in deviceList" :key="index" :class="{'curEnt':curSn==item.imei}" @click="getDeviceId(item)">
                            <i class="el-icon-monitor" style="font-size:2.5vh;"></i>
                            <div class="unit-name color4" style="padding-left:1vh;">
                                <p :title="item.imei" class="nowrap">{{item.imei+'（'+item.statusName+'）'}}</p>
                                <p class="desc" :title="item.locationDesc"> {{item.locationDesc}}</p>
                            </div>
                        </li>
                    </ul>
                </div>
            </div> -->
            <div class="main-right">
                <!-- <div class="box-head">
                    <span style="font-size:18px;color:#409EFF;">设备跟踪</span>
                    <div style="flex:1;padding:0 50px;">
                        <el-slider
                            v-model="showTime"
                            :step='1'
                            :max="1440"
                            :marks="timeMark"
                            :format-tooltip="formatToolTip"
                            @change="showTimeChange"
                            >
                        </el-slider>
                    </div>
                    <div>
                        <el-date-picker
                            v-model="time"
                            align="right"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期"
                            @change="timeChange"
                            :picker-options="pickerOptions">
                        </el-date-picker>
                        <el-button type="primary" v-if="!trailDisable" @click="showTrail" style="margin-left:20px;">回看</el-button>
                        <el-button type="primary" v-else style="margin-left:20px;">{{curTime}}</el-button>
                    </div>
                </div> -->
                <div class="box-main">
                    <baidu-map class="map-box" :center="center" :zoom="16" @ready="handler" @click="getClickInfo">
                        <bm-marker v-for="item in points" @click="clickHandler(item)" :key="item.id" :position="item.position"  :icon="{url: require('../../../assets/image/worker_icon.png'), size: {width: 24, height: 40}}">
                        </bm-marker>
                    </baidu-map>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import util from '../../../untils/util'
import myHttp from '../../../untils/port'
import base from '../../../untils/base'
export default {
    data(){
        return{
            groupId:'',
            deviceList:[],//设备列表
            curSn:'',//当前设备sn
            map:undefined,
            center: {
                lng: 117.285033,
                lat: 31.86515
            },
            worker:undefined, 
            BMap:undefined,
            timesOut:undefined,
            id:'',
            time:util.myTime.getCurTime(),
            pageTitle:'',
            pickerOptions: { //时间插件参数
                disabledDate(time) {
                return time.getTime() > Date.now();
                },
                shortcuts: [{
                text: '今天',
                onClick(picker) {
                    picker.$emit('pick', new Date());
                }
                }, {
                text: '昨天',
                onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                }
                }, {
                text: '一周前',
                onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', date);
                }
                }]
            },
            allPoint:[],
            playPoint:[],//回看轨迹
            dataPoint:[],//
            curTime:'',//当前路径的时间
            showTime:0,//路径展示开始时间
            showTimeDate:'00:00:00',
            trailDisable:false,
            timeMark:{
                0:'00:00',
                // 60:'01:00',
                // 120:'02:00',
                // 180:'03:00',
                // 240:'04:00',
                // 300:'05:00',
                360:'06:00',
                // 420:'07:00',
                // 480:'08:00',
                // 540:'09:00',
                // 600:'10:00',
                // 660:'11:00',
                720:'12:00',
                // 780:'13:00',
                // 840:'14:00',
                // 900:'15:00',
                // 960:'16:00',
                // 1020:'17:00',
                1080:'18:00',
                // 1140:'19:00',
                // 1200:'20:00',
                // 1260:'21:00',
                // 1320:'22:00',
                // 1380:'23:00',
                1440:'24:00',
            },
            points:[],//在场人员
        }
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        // this.getDict()
        // var params = this.$route.params
        // this.id = params.id
        //this.getInfo()
    },
    methods:{

        //获取考勤定位设备
        getDeviceList(){
            var that = this
            myHttp.getMachineList({
                projectId:this.groupId
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo||[]
                    if(list.length>0){
                        for (var i = 0; i < list.length; i++) {
                             list[i].locationDesc = list[i].locationDesc == 'undefined'?'':list[i].locationDesc
                            list[i].statusName = that.filterSatus(list[i].status)
                        }
                        that.curSn = list[0].imei
                        that.getData()
                    }
                    that.deviceList = list
                }
            })
        },
        //获取类型
        filterSatus(str){
            var list = this.typeNameAll
            var result = ''
            for(var i=0;i<list.length;i++){
                if(str == list[i].value){
                result = list[i].label
                }
            }
            return result
        },
        //获取当前设备imei
        getDeviceId(obj){
            this.curSn = obj.imei
            this.getData()
        },
        //获取当前在场人员
        // getLocation(){
        //     var that = this
        //     myHttp.getLocation({
        //         projectId:this.groupId 
        //     }).then(function(resp){
        //         if(resp.data.code=='200'){
        //             //console.log(resp)
        //             var list = resp.data.data.TeamsPerson||[]
        //             var viewPoints = []
        //             for(var i=0;i<list.length;i++){
        //                 var position = list[i].location.split(',')
        //                 list[i].position = {lng: parseFloat(position[0]), lat: parseFloat(position[1])}
        //                 viewPoints.push(list[i].position)
        //             }
        //             if(list.length>0){
        //                 that.points = list
        //                 that.map.setViewport(viewPoints);
        //             }
        //         }else{
        //             that.$message.error(resp.data.msg)
        //         }
        //     })
        // },

        // formatToolTip(val){
        //     let hour = 0
        //     let min = 0
        //     let ms = val * 60
        //     hour = parseInt(ms / 3600)
        //     if (hour < 10) {
        //         hour = '0' + hour.toString()
        //     } else {
        //         hour = hour.toString()
        //     }
        //     min = parseInt(val % 60)
        //     if (min < 10) {
        //         min = '0'+min.toString()
        //     } else {
        //         min = min.toString()
        //     }
        //     let time = hour + ':' + min
        //     return time
        // },
        //获取电子围栏
        getAttendArea(){
            var that = this;
            myHttp.getProjectById({
                id: this.groupId
            }).then(function (resp) {
                if (resp.data.code == '200') {
                    var data = resp.data.data.project;
                    that.showFenceArea(data.enclosure);
                    
                } else {
                    that.$message.error(resp.data.msg);
                }
            }, function (error) {});
        },
        //展示电子围栏
        showFenceArea(mapArea){
            if (mapArea != undefined && mapArea != ""){
                this.allPoint = JSON.parse(mapArea);
                for (var j = 0; j < this.allPoint.length; j++) {
                    this.currentPonit = this.allPoint[j];
                    var list = [];
                    for (var i = 0; i < this.currentPonit.length; i++) {
                        list.push(new BMap.Point(this.currentPonit[i].lng, this.currentPonit[i].lat));
                        var point = new BMap.Point(this.currentPonit[i].lng, this.currentPonit[i].lat);
                        // pointList.push(point);
                        var marker = new BMap.Marker(point);
                        var index = i + 1;
                        var label = new BMap.Label(index, {
                            offset: new BMap.Size(5, 4)
                        });
                        label.setStyle({
                            background: 'none', color: '#fff', border: 'none'//只要对label样式进行设置就可达到在标注图标上显示数字的效果
                        });
                        marker.setLabel(label);//显示地理名称
                        //this.map.addOverlay(marker);
                    }
                    var polygonList = new BMap.Polygon(list, {
                        strokeColor: "blue",
                        strokeWeight: 2,
                        strokeOpacity: 0.5,
                        strokeStyle: 'dashed',
                        fillOpacity: 0.3
                    });  //创建多边形
                    this.map.addOverlay(polygonList);
                }
                this.currentPonit = []
            }
        },
        //获取路径
        getData(){
            var that = this
            myHttp.selectMaxDateGpsRecord({
                projectId:this.groupId,
                teamsType:'2'
            }).then(function(resp){
                if(resp.data.code=='200'){
                    console.log(resp)
                    var list = resp.data.data.gpsList||[]
                    var result = []
                    var viewPoints = []
                    for(var i=0;i<list.length;i++){
                        if(list[i].latitude&&list[i].latitude!=''&&list[i].longitude&&list[i].longitude!=''){
                            list[i].position = {lng: parseFloat(list[i].longitude), lat: parseFloat(list[i].latitude)}
                            result.push(list[i])
                            viewPoints.push(list[i].position)
                        }
                    }
                    that.points = result
                    that.map.setViewport(viewPoints);
                }
            })
            // myHttp.getGpsDataBySn({
            //     projectId:this.groupId,
            //     sn:this.curSn,
            //     days:this.time+' '+this.showTimeDate,
            // }).then(function(resp){
            //     if(resp.data.code=='200'){
            //         that.clearBaiDu()
            //         var list = resp.data.data.dataBySn||[]
            //         that.dataPoint = list
            //         if(list.length==0){
            //             that.playPoint = []
            //             that.$message.error('暂无运行路线！')
            //             return
            //         }
            //         var datas = list
            //         var PointArr = [];
            //         if(datas.length != 0) {
            //             for(let is in datas) {
            //                 PointArr.push({lat:parseFloat(datas[is].latitude),lng:parseFloat(datas[is].longitude)}) ;   
            //             }
            //         }else{
            //             PointArr.push({lat:31.855084,lng:117.140395}) ;
            //         }
            //         var pois = [];//路线
                    
                    
            //         for(let i in PointArr) {
            //             pois.push(new BMap.Point(PointArr[i].lng,PointArr[i].lat));
            //         }
            //         that.playPoint = pois
                    
            //         if(that.trailDisable){
            //             that.dingshi(pois)
            //         }
            //         //that.dingshi(pois)
            //     }else{
            //         that.$message.error(resp.data.msg)
            //     }
            // })
        },
        //地图展示
        handler({ BMap, map }) {
            this.map = map
            this.BMap = BMap
            this.map.enableScrollWheelZoom();
            map.addControl(new BMap.ScaleControl());
            this.getData()
            this.getAttendArea()
            // this.getLocation()
        },
        addStartMarker(point, name,mapInit) {
            var start = require('../../../assets/image/start.png')
            var  myIcon  =  new BMap.Icon(start, new BMap.Size(45,45),{
                anchor: new BMap.Size(20, 45),//这句表示图片相对于所加的点的位置mapStart
                imageSize:new BMap.Size(45, 45) //图标所用的图片的大小，此功能的作用等同于CSS中的background-size属性。可用于实现高清屏的高清效果
            });
                window.marker = new BMap.Marker(point,{icon:myIcon});  // 创建标注
                mapInit.addOverlay(marker);
        },
        dingshi(pois){
            //var pois = this.playPoint
            this.clearBaiDu()
            if(pois.length==0){
                this.$message.error('暂无运行路线！')
                return
            }
            //人
            if(this.worker){
                this.worker.setPosition(pois[0])
                this.map.panTo(pois[0]); 
            }else{
                var worker_icon = new BMap.Icon(require('../../../assets/image/location.png'), new BMap.Size(25,27),{
                    anchor: new BMap.Size(12, 13),//这句表示图片相对于所加的点的位置mapStart
                    imageSize:new BMap.Size(25, 27) //图标所用的图片的大小，此功能的作用等同于CSS中的background-size属性。可用于实现高清屏的高清效果
                });
                this.worker = new BMap.Marker(pois[0],{icon:worker_icon})
                this.map.addOverlay(this.worker);
            }
            
            var that = this
            var i=0
            this.timesOut = setInterval(() => {
                if(i<pois.length){
                    if(i==0){
                        console.log('回放开始！')
                        that.trailDisable = true
                    }
                    i++
                    that.curTime = that.dataPoint[i] && that.dataPoint[i].updateDate||'回看中...'
                    that.play(i,pois)
                }else{
                    console.log('回放结束！')
                    that.curTime = ''
                    that.trailDisable = false
                    clearInterval(that.timesOut)
                }
                
            }, 100);
        },
        getClickInfo(e){
            //console.log(e)
            if(!this.curIndex){
                var allOverlay = this.map.getOverlays();
                for(var i=0;i<allOverlay.length;i++){
                    if(allOverlay[i].toString()=="[object Overlay]"){
                        this.map.removeOverlay(allOverlay[i]);
                    }
                }
            }
            this.infoWindowClose()
        },
        //关闭
        infoWindowClose(){
            this.curIndex = undefined
        },
        play(index,list){
            var point = list[index];
            if(this.map.getDistance(list[index - 1],point).toFixed(2)>20){
                this.map.panTo(point);  
            }
            this.worker.setPosition(point)
            var polyline = new BMap.Polyline([list[index - 1], point], {
                enableEditing: false,//是否启用线编辑，默认为false
                enableClicking: true,//是否响应点击事件，默认为true
                // icons:[icon],
                strokeWeight:'5',//折线的宽度，以像素为单位
                strokeOpacity: 1,//折线的透明度，取值范围0 - 1
                strokeColor:"#349c00" //折线颜色
            });
            this.map.addOverlay(polyline) 
        },
        goBack(){
            this.$router.go(-1)
        },
        //监听时间
        timeChange(){
            this.getData()
        },
        //回看
        showTrail(){
            this.dingshi(this.playPoint)
        },
        //
        showTimeChange(e){
            var hour = parseInt(e/60)
            hour = hour<10?'0'+hour:hour
            var min = parseInt(e%60)
            min = min<10?'0'+min:min
            this.showTimeDate = hour + ':' + min+':00'
            if(this.trailDisable){
                //this.trailDisable = false
                clearInterval(this.timesOut)
            }
            this.getData()
        },
        //删除固定的覆盖物
        clearBaiDu(){
            var allOverlay = this.map.getOverlays();
            for(var i = 0;i<allOverlay.length;i++) {
                if(allOverlay[i].toString()=="[object Polyline]"){
                    this.map.removeOverlay(allOverlay[i]);
                }
            }
        },

        //点击定位人员
        clickHandler(e){
            this.curIndex = e
            this.showMapMarker(e)
        },
        //展示地图数据
        showMapMarker(obj){
            var _selt = this
            // 复杂的自定义覆盖物
            function ComplexCustomOverlay(point,obj){
                this._point = point;
                this._option = obj
            }
            ComplexCustomOverlay.prototype = new BMap.Overlay();
            ComplexCustomOverlay.prototype.initialize = function(map){
                this._map = map;
                var option = this._option;
                var div = this._div = document.createElement("div");
                div.style.position = "absolute";
                div.style.zIndex = BMap.Overlay.getZIndex(this._point.lat);
                div.style.height = "270px";
                div.style.width = "200px";
                div.style.background = "rgba(19, 46, 140, 0.8)";
                div.style.borderRadius = "5px";
                div.style.padding = "10px";
                div.style.cursor = 'pointer'
                var that = this;

                //图片
                var imgDiv = document.createElement("img");
                imgDiv.style.position = "relative";
                imgDiv.style.width = "180px";
                imgDiv.style.height = "150px";
                imgDiv.style.marginBottom = "10px";
                var imgs = option.photoFile
                var img = option.photoFile&&option.photoFile!=''?base.httpCtx+option.photoFile:''
                if(img==''){
                    imgDiv.src = require('../../../assets/image/zanwutupian.png')
                }else{
                    imgDiv.src = img
                }
                div.appendChild(imgDiv);

                //人员名称
                var nameText = document.createElement("p");
                nameText.style.position = "relative";
                nameText.style.width = "100%";
                nameText.style.height = "20px";
                nameText.style.fontSize = "14px";
                nameText.style.color = "rgba(255, 255, 255, 1)";
                nameText.style.whiteSpace = "nowrap";
                nameText.style.textOverflow = "ellipsis";
                nameText.style.overflow = "hidden";
                nameText.innerHTML = option.personName||'';
                nameText.title = option.personName||'';
                div.appendChild(nameText);

                // 班组
                var progressText = document.createElement("p");
                progressText.style.position = "relative";
                progressText.style.width = "100%";
                progressText.style.height = "20px";
                progressText.style.fontSize = "12px";
                progressText.style.color = "rgba(255, 255, 255, 1)";
                progressText.innerHTML = '班组：'+ option.teamsName||'';
                div.appendChild(progressText);

                //时间
                var addrText = document.createElement("p");
                addrText.style.position = "relative";
                addrText.style.width = "100%";
                addrText.style.height = "20px";
                addrText.style.fontSize = "12px";
                addrText.style.color = "rgba(255, 255, 255, 1)";
                addrText.style.whiteSpace = "nowrap";
                addrText.style.textOverflow = "ellipsis";
                addrText.style.overflow = "hidden";
                addrText.title = option.address||'';
                addrText.innerHTML = '时间：'+option.updateDate;
                div.appendChild(addrText);

                //轨迹
                var trapA = document.createElement("a");
                trapA.style.position = "relative";
                trapA.style.width = "100%";
                trapA.style.height = "30px";
                trapA.style.fontSize = "12px";
                trapA.style.color = "rgba(255, 255, 255, 1)";
                trapA.style.whiteSpace = "nowrap";
                trapA.style.textOverflow = "ellipsis";
                trapA.style.overflow = "hidden";
                trapA.title = option.address||'';
                trapA.className = 'aHover'
                
                trapA.innerHTML = '查看轨迹';
                div.appendChild(trapA);
                trapA.onclick = function(){
                    _selt.$router.push({path:'/hatSign/'+option.personId+'/'+option.sn+'/'+option.personName})
                }
                div.onclick = function(){
                    // alert(123)
                }

                map.getPanes().labelPane.appendChild(div);
                
                return div;
            }
            ComplexCustomOverlay.prototype.draw = function(){
                var map = this._map;
                var pixel = map.pointToOverlayPixel(this._point);
                this._div.style.left = (pixel.x + 20) + 'px' ;
                this._div.style.top  = pixel.y  + 'px' ;
            }
            var allOverlay = this.map.getOverlays();
            for(var i=0;i<allOverlay.length;i++){
                if(allOverlay[i].toString()=="[object Overlay]"){
                    this.map.removeOverlay(allOverlay[i]);
                }
            }
            var gpsLi = obj.position;
            var myCompOverlay = new ComplexCustomOverlay(new BMap.Point(gpsLi.lng, gpsLi.lat),obj);
            this.map.addOverlay(myCompOverlay);
        },

        // 字典接口
        getDict() {
            var that = this
            myHttp.getDictByType({
                type: 'attend_type'
            }).then(function(resp) {
                if (resp.data.code == '200') {
                    that.typeNameAll = resp.data.data.dictList
                    that.getDeviceList()
                } else {
                    that.$message.error(resp.data.msg)
                }
            })
        },
    }
}
</script>
<style scoped>
    .box-second{
        width: 100%;
        height: 100%;
        position: relative;
        background: #fff;
    }
    /* .title{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        padding-left: 1vw;
    }
    .main{
        width: 100%;
        height: calc( 100% - 3vh );
        position: relative;
        display: flex;
        padding: 0 1vw 0.5vw;
        flex-wrap: wrap;
    } */
    .main-left{
        width: 15vw;
        height: 100%;
        position: relative;
        /* overflow: auto; */
        background: #fff;
        border-radius: 0.5vh;
    }
    .main-left-p{
        width: 100%;
        height: 5%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        justify-content:space-between;
        padding: 0 1vh;
    }
    .main-left-list{
        width: 100%;
        height: 85%;
        position: relative;
        overflow: auto;
    }
    .main-left-list li{
        width: 100%;
        height: 6vh;
        position: relative;
        padding:1vh 2vh;
        display: flex;
        align-content: center;
        align-items: center;
        border-bottom: 1px solid #eee;
        cursor: pointer;
    }
    .main-left-list li:hover{
        background: #eee;
    }
    .curEnt{
        background: #E7F1FB;
    }
    .unit-name{
        width: calc( 100% - 3vh );
        height: 100%;
        position: relative;
        display: flex;
        align-items: center;
        align-content: center;
        padding-left: 1vh;
        flex-wrap: wrap;
    }
    .unit-name p{
        width: 100%;
        text-align: left;
    }
    .unit-name .desc{
        color: #5f5b5b;
    }
    .main-right{
        /* width: calc( 100% - 15vw ); */
        width: 100%;
        height: 100%;
        position: relative;
        /* padding-left: 1vw; */
        display: flex;
        flex-wrap: wrap;
    }
    .box-head{
        width: 100%;
        height: 8vh;
        position: relative;
        display: flex;
        padding: 10px 20px;
        background: #fff;
        align-content: center;
        align-items: center;
        justify-content: space-between;
        border-bottom: 2px solid #ecf0f5;
    }
    .box-main{
        width: 100%;
        /* height: calc( 100% - 6vh ); */
        height: 100%;
        position: relative;
    }
    .timeSlid{
        width: 80px;
        height: 100%;
        left: 0;
        top: 0;
        position: absolute;
        background: rgba(255, 255, 255, 0.8);
        padding: 15px 0;
        box-sizing: border-box;
    }
    .map-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
</style>

<style>
.el-slider__marks{
    width:100%;
}
@import '../../../assets/css/common.css';
.aHover:hover{
    color: #67C23A !important;
}
</style>